import { defineComponent as _defineComponent } from 'vue'
import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import type { PropType } from 'vue'
  import type { CourseItem } from '@/services/interfaces/Course'
  import useCourse from '@/composables/useCourse'
  import { UserModule } from '@/store/modules/user'
  import useSegment from '@/composables/useSegment'
  import { useRoute, useRouter } from 'vue-router/composables'
  import { computed } from 'vue'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'
  import useShopifyClient from '@/composables/useShopifyClient'
  import useCommonMixin from '@/composables/useCommonMixin'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseInfoCTA',
  props: {
    course: {
      type: Object as PropType<CourseItem | null>,
      required: true,
    },
    productAmount: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  const {
    currentCourseId,
    firstCourseModule,
    canBuyCourses,
    routeToFirstCourseModule,
    showStartCourseForFreeModal,
    courseWithFreeModule,
  } = useCourse()
  const { createShopifyCheckout } = useShopifyClient()
  const { tryCourseForFreeButtonClicked, coursePurchaseIntended } = useSegment()
  const { arrowRight } = useIcons()
  const { isDesktopDevice, isMobileDevice } = useBreakpoint()
  const { currencyFormatDE, showIDDCoursesCheckoutModal } = useCommonMixin()
  const route = useRoute()
  const router = useRouter()

  

  const canAccessForFree = computed(() => props.course?.free || props.course?.trial)

  const canUseShopifyCheckout = computed(() => !!props.course?.shopifyProductId)

  const trackCoursePurchaseIntended = () => {
    coursePurchaseIntended(currentCourseId.value, props.course?.title || '', 'course_details_page')
  }

  const tryCourseForFree = () => {
    if ((props.course?.trial && !props.course?.purchased) || props.course?.free) {
      if (courseWithFreeModule.value.courseId && courseWithFreeModule.value.moduleId) {
        return eventBus.$router
          .push({
            name: 'CourseModule',
            params: {
              courseId: courseWithFreeModule.value.courseId,
              moduleId: courseWithFreeModule.value.moduleId,
            },
          })
          .catch(() => {
            return
          })
      } else {
        return routeToFirstCourseModule(currentCourseId.value)
      }
    } else {
      // the fact that you are seeing the page, and you are not logged in implies company is public
      if (!UserModule.isLoggedInUser) {
        return router.push(`/login?redirect=${route.fullPath}`).catch(() => {
          return
        })
      }

      tryCourseForFreeButtonClicked(currentCourseId.value, props.course?.title || '')
      return showStartCourseForFreeModal(currentCourseId.value)
    }
  }

  const shopifyCheckout = () => {
    if (props.course?.isIddCourse) {
      showIDDCoursesCheckoutModal(currencyFormatDE(props.productAmount))
    } else {
      trackCoursePurchaseIntended()
      createShopifyCheckout()
    }
  }

return { __sfc: true,currentCourseId, firstCourseModule, canBuyCourses, routeToFirstCourseModule, showStartCourseForFreeModal, courseWithFreeModule, createShopifyCheckout, tryCourseForFreeButtonClicked, coursePurchaseIntended, arrowRight, isDesktopDevice, isMobileDevice, currencyFormatDE, showIDDCoursesCheckoutModal, route, router, props, canAccessForFree, canUseShopifyCheckout, trackCoursePurchaseIntended, tryCourseForFree, shopifyCheckout, SVGRenderer, KetchUpButton, useCourse, UserModule, useSegment, useRoute, useRouter, computed, useIcons, useBreakpoint, useShopifyClient, useCommonMixin, eventBus }
}

})